"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const query_string_1 = __importDefault(require("query-string"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const tags_1 = require("companion-app-components/flux/tags");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const categoryGroupsActions_1 = require("companion-app-components/flux/category-groups/categoryGroupsActions");
const categoryGroupListsActions_1 = require("companion-app-components/flux/category-group-lists/categoryGroupListsActions");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const QCard_1 = __importDefault(require("components/QCard"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const WFBudgetSetup_1 = __importDefault(require("components/Dialogs/WFBudgetSetup"));
const actions_1 = require("components/Dialogs/WfBillScout/actions");
const actions_2 = require("data/AccountDiscovery/actions");
const config_1 = require("./config");
const GettingStartedModulePage_1 = __importDefault(require("./GettingStartedModulePage"));
const GettingStartedWebFirst = () => {
    const [setupStep, setSetupStep] = (0, react_1.useState)(0);
    const [startedResourceAddNum, setStartedResourceAddNum] = (0, react_1.useState)(false);
    const [stepCompletedSuccessfully, setStepCompletedSuccessfully] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const locationRef = (0, react_1.useRef)(location);
    const tier = (0, react_redux_1.useSelector)(entitlements_1.entitlementsSelectors.getTopTierEntitlement);
    const accountsById = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const scheduledTransactions = (0, react_redux_1.useSelector)(scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions);
    const showScheduledTransactions = (0, react_redux_1.useSelector)(feature_flags_1.featureFlagsSelectors.getFeatureFlags).get('scheduledTransactions');
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const isDeluxeUser = () => {
        if (!tier || !tier.id) {
            return undefined;
        }
        return ['US_QUICKEN_DELUXE', 'CA_QUICKEN_DELUXE'].includes(tier.id);
    };
    const hasAccounts = () => accountsById.size > 0;
    const getConfig = () => (0, config_1.staticConfig)(hasAccounts(), stepCompletedSuccessfully, showScheduledTransactions, isDeluxeUser());
    const getSetupState = (locationParam) => {
        const query = query_string_1.default.parse(locationParam.search);
        if (query) {
            const navPageIndex = getConfig().findIndex((rec) => rec.page === query.page);
            if (navPageIndex >= 0) {
                setSetupStep(navPageIndex);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        getSetupState(window.location);
        const timeout = setTimeout(() => {
            dispatch(categories_1.categoriesActions.getCategories());
            dispatch((0, categoryGroupListsActions_1.getCategoryGroupListsAction)());
            dispatch((0, categoryGroupsActions_1.getCategoryGroupsAction)());
            dispatch(tags_1.tagsActions.getTags());
        }, 1000);
        return () => clearTimeout(timeout);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (locationRef.current.search !== location.search) {
            locationRef.current = location;
            getSetupState(location);
        }
        if (startedResourceAddNum !== false) {
            switch (setupStep) {
                case 0:
                    // @ts-expect-error: Operator '>' cannot be applied to types 'number' and 'string | number | boolean'.
                    if (accountsById.size > startedResourceAddNum) {
                        setStepCompletedSuccessfully(true);
                        setStartedResourceAddNum(false);
                    }
                    break;
                case 1: {
                    const nextVerifiedSchTxns = scheduledTransactions.size && scheduledTransactions.filter((x) => x.isUserVerified);
                    // @ts-expect-error: Property 'size' does not exist on type '0'.
                    if (nextVerifiedSchTxns.size > startedResourceAddNum) {
                        setStepCompletedSuccessfully(true);
                        setStartedResourceAddNum(false);
                    }
                    break;
                }
                default:
                    break;
            }
        }
    }, [location, accountsById, scheduledTransactions]); // eslint-disable-line react-hooks/exhaustive-deps
    const onButtonClick = (_e, value) => {
        switch (value) {
            case 'addAccount':
                core_1.tracker.track(core_1.tracker.events.wizardAddAccount);
                setStartedResourceAddNum(accountsById.size);
                dispatch((0, actions_2.doAccountDiscovery)({ initiator: 'getting started' }));
                break;
            case 'setUpBills':
                core_1.tracker.track(core_1.tracker.events.wizardBillscout);
                setStartedResourceAddNum(scheduledTransactions.filter((x) => x.isUserVerified).size);
                dispatch((0, actions_1.doWFBillsScout)());
                break;
            case 'createBudget':
                core_1.tracker.track(core_1.tracker.events.wizardAddBudget);
                setStartedResourceAddNum('budgetPending');
                break;
            default:
                break;
        }
    };
    const closeToDashboard = (noSkip) => {
        if (noSkip) {
            dialogAlert('', 'Do you want to sign out?', (b) => {
                if (b.btnPressed === 'Yes') {
                    core_1.tracker.track(core_1.tracker.events.wizardWFClose);
                    dispatch(auth_1.authActions.authLogout({
                        reason: 'AUTH_LOGOUT_USER_INITIATED',
                    }, {
                        context: 'GettingStartedWebFirst',
                    }));
                }
            }, ['Yes', 'No']);
        }
        else {
            navigate('/');
        }
    };
    const advanceFlow = () => {
        if (setupStep < (getConfig().length - 1)) {
            setStepCompletedSuccessfully(false);
            setSetupStep(setupStep + 1);
        }
        else {
            // Skip the budgets section
            if (!stepCompletedSuccessfully) {
                core_1.tracker.track(core_1.tracker.events.skipBudgetFlow);
            }
            closeToDashboard();
        }
    };
    const stepVal = accountsById.size > 0 ? setupStep : 0;
    const configRecord = getConfig()[stepVal];
    const skipText = (setupStep < (getConfig().length - 1)) ? 'Next' : 'Done';
    const renderNext = !configRecord.noSkip; //  && (this.state.setupStep < (this.getConfig().length - 1));
    const successQCard = stepCompletedSuccessfully && configRecord.successQCard;
    return (<>
      {successQCard && !isEntitySharedUser &&
            <QCard_1.default name="setup" cards={successQCard} open initialCard="firstCard"/>}
      <GettingStartedModulePage_1.default onCompleted={renderNext ? advanceFlow : null} config={configRecord} onClose={() => closeToDashboard(configRecord.noSkip)} skipText={skipText} onButtonClick={onButtonClick} showSuccess={stepCompletedSuccessfully}/>
      {startedResourceAddNum === 'budgetPending' &&
            <WFBudgetSetup_1.default onClose={() => {
                    setStepCompletedSuccessfully(true);
                    setStartedResourceAddNum(false);
                }}/>}
    </>);
};
exports.default = GettingStartedWebFirst;
